import { RouteRecordRaw } from "vue-router"

const constantsRoutes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录"
    },
    component: () => import("@/views/Login.vue")
  },
  {
    path: "/authorize",
    name: "Authorize",
    meta: {
      title: "授权"
    },
    component: () => import("@/views/Authorize.vue")
  },
  {
    path: "/confirm",
    name: "confirm",
    meta: {
      title: "快手授权",
      hidden: true
    },
    component: () => import("@/views/KSAuthorize.vue")
  }
]

export default constantsRoutes
